<table class="report-table bottom-spacer" *ngIf="!useResponsive || !utilService.isMobile">
  <thead>
    <tr>
      <ng-container *ngFor="let column of config.header.items">
        <th *ngIf="!column.isHidden" [class]="column.cssClass" [rowSpan]="column.rowSpan || 1" [colSpan]="column.colSpan || 1"
            [width]="column.width ? column.width + '%' : 'auto'">
          <ng-container *ngIf="column.inlineGrid">
            <div class="inline-grid" [ngStyle]="{'grid-template-columns': column.inlineGridTemplate || 'unset'}">
              <ng-container *ngTemplateOutlet="cell; context: { column }"></ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="!column.inlineGrid">
            <ng-container *ngTemplateOutlet="cell; context: { column }"></ng-container>
          </ng-container>
        </th>
      </ng-container>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngIf="data?.length">
      <ng-container *ngIf="config.customSelector">
        <ng-container *ngFor="let parent of data">
          <ng-container *ngTemplateOutlet="bodyRepeater; context: { rows: parent[config.customSelector], parent }"></ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!config.customSelector">
        <ng-container *ngTemplateOutlet="bodyRepeater; context: { rows: data }"></ng-container>
      </ng-container>
    </ng-container>
  </tbody>
  <tfoot *ngIf="config.footer?.items?.length">
    <tr>
      <ng-container *ngFor="let column of config.footer.items">
        <th *ngIf="!column.isHidden" [class]="column.cssClass" [rowSpan]="column.rowSpan || 1" [colSpan]="column.colSpan || 1"
            [width]="column.width ? column.width + '%' : 'auto'">
          <ng-container *ngIf="config.useFooterData">
            <ng-container *ngIf="column.inlineGrid">
              <div class="inline-grid" [ngStyle]="{'grid-template-columns': column.inlineGridTemplate || 'unset'}">
                <ng-container *ngTemplateOutlet="cell; context: { column, item: footerData }"></ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="!column.inlineGrid">
              <ng-container *ngTemplateOutlet="cell; context: { column, item: footerData }"></ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!config.useFooterData">
            <ng-container *ngIf="column.inlineGrid">
              <div class="inline-grid" [ngStyle]="{'grid-template-columns': column.inlineGridTemplate || 'unset'}">
                <ng-container *ngTemplateOutlet="cell; context: { column }"></ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="!column.inlineGrid">
              <ng-container *ngTemplateOutlet="cell; context: { column }"></ng-container>
            </ng-container>
          </ng-container>
        </th>
      </ng-container>
    </tr>
  </tfoot>
</table>
<div class="mobile bottom-spacer" *ngIf="useResponsive && utilService.isMobile">
  <div class="flex flex-center bottom-spacer select-all-block" *ngIf="!!clickable?.length || useCartSelectionMap">
    <mat-checkbox (change)="toggleAll($event)" [checked]="areAllSelected" [indeterminate]="areSomeSelected">
      <span class="heading-5 medium">
        {{ 'general.api_general_select_all' | translate }}
      </span>
    </mat-checkbox>
  </div>
  <hr class="no-margin">
  <ng-container *ngIf="data?.length">
    <ng-container *ngIf="config.customSelector">
      <ng-container *ngFor="let parent of data">
        <ng-container *ngTemplateOutlet="mobileBodyRepeater; context: { rows: parent[config.customSelector], parent }"></ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!config.customSelector">
      <ng-container *ngTemplateOutlet="mobileBodyRepeater; context: { rows: data }"></ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="config.footer?.items?.length">
    <div class="listing-block">
      <div class="header-block flex flex-center space-between bottom-spacer">
        <div class="max-width flex">
          <ng-container *ngFor="let column of config.footer.items">
            <div class="heading-5 text-base bold" *ngIf="column.mobileHeaderItem && !getIsHidden(column, footerData)">
              {{ formatText(column.format, footerData, column.useModel) | translate }}
            </div>
          </ng-container>
        </div>
      </div>
      <table class="mobile-max-width mobile-columns">
        <tbody>
        <ng-container *ngFor="let column of config.footer.items">
          <ng-container *ngIf="!column.mobileHeaderItem && !getIsHidden(column, footerData) && column?.format?.length">
            <tr *ngIf="!column.inlineGrid">
              <ng-container *ngTemplateOutlet="mobileCell; context: { column, item: footerData }"></ng-container>
            </tr>
            <ng-container *ngIf="column.inlineGrid">
              <tr>
                <td colspan="2">
                  <div class="inline-grid" [ngStyle]="{'grid-template-columns': column.inlineGridTemplate || 'unset'}">
                    <div class="inline-grid-column" *ngIf="!column.inlineGridSkipParent" [class]="getHeaderCssClass(column.key)">
                      <b>{{ getHeaderText(column.key) | translate }}</b>
                    </div>
                    <ng-container *ngFor="let child of column.children">
                      <div class="inline-grid-column" *ngIf="!getIsHidden(child, footerData)" [class]="getHeaderChildCssClass(column.key, child.key)">
                        <b>{{ getHeaderChildText(column.key, child.key) | translate }}</b>
                      </div>
                    </ng-container>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div class="inline-grid" [ngStyle]="{'grid-template-columns': column.inlineGridTemplate || 'unset'}">
                    <ng-container *ngTemplateOutlet="mobileGridCell; context: { column, item: footerData }"></ng-container>
                    <ng-container *ngFor="let child of column.children">
                      <ng-container *ngIf="!getIsHidden(child, footerData)">
                        <ng-container *ngTemplateOutlet="mobileGridCell; context: { column: child, item: footerData }"></ng-container>
                      </ng-container>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
        </tbody>
      </table>
      <hr class="no-margin top-spacer">
    </div>
  </ng-container>
</div>

<ng-template #bodyRepeater let-rows="rows" let-parent="parent">
  <tr *ngFor="let item of rows; let index = index; let even = even" [ngClass]="{'alternate' : even}" [class]="getRowClass(item)">
    <ng-container *ngFor="let column of config.body.items">
      <td *ngIf="!getIsHidden(column, item)" [class]="column.cssClass" [rowSpan]="column.rowSpan || 1" [colSpan]="column.colSpan || 1"
          [width]="column.width ? column.width + '%' : 'auto'">
        <ng-container *ngIf="column.inlineGrid">
          <div class="inline-grid" [ngStyle]="{'grid-template-columns': column.inlineGridTemplate || 'unset'}">
            <ng-container *ngTemplateOutlet="cell; context: { column, item: (column.useParent ? parent : item), index, parent }"></ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="!column.inlineGrid">
          <ng-container *ngTemplateOutlet="cell; context: { column, item: (column.useParent ? parent : item), index, parent }"></ng-container>
        </ng-container>
      </td>
    </ng-container>
  </tr>
</ng-template>

<ng-template #mobileBodyRepeater let-rows="rows" let-parent="parent">
  <div class="listing-block" *ngFor="let item of rows; let index = index; let even = even">
    <div class="header-block flex flex-center space-between bottom-spacer">
      <div class="max-width flex">
        <ng-container *ngFor="let column of config.body.items">
          <ng-container *ngIf="column.mobileHeaderItem && !getIsHidden(column, item) && column.type === DataTableRowItemType.Checkbox">
            <ng-container *ngTemplateOutlet="mobileHeaderCell; context: { column, item: (column.useParent ? parent : item), index, parent }"></ng-container>
          </ng-container>
        </ng-container>
        <div class="max-width">
          <ng-container *ngFor="let column of config.body.items">
            <ng-container *ngIf="column.mobileHeaderItem && !getIsHidden(column, item) && column.type !== DataTableRowItemType.Button && column.type !== DataTableRowItemType.Checkbox">
              <ng-container *ngTemplateOutlet="mobileHeaderCell; context: { column, item: (column.useParent ? parent : item), index, parent }"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <ng-container *ngFor="let column of config.body.items">
        <ng-container *ngIf="column.mobileHeaderItem && !getIsHidden(column, item) && column.type === DataTableRowItemType.Button">
          <ng-container *ngTemplateOutlet="mobileHeaderCell; context: { column, item: (column.useParent ? parent : item), index, parent }"></ng-container>
        </ng-container>
      </ng-container>
    </div>
    <table class="mobile-max-width mobile-columns">
      <tbody>
      <ng-container *ngFor="let column of config.body.items">
        <ng-container *ngIf="!column.mobileHeaderItem && !getIsHidden(column, item)">
          <tr *ngIf="!column.inlineGrid">
            <ng-container *ngTemplateOutlet="mobileCell; context: { column, item: (column.useParent ? parent : item), index, parent }"></ng-container>
          </tr>
          <ng-container *ngIf="column.inlineGrid">
            <tr>
              <td colspan="2">
                <div class="inline-grid" [ngStyle]="{'grid-template-columns': column.inlineGridTemplate || 'unset'}">
                  <div class="inline-grid-column" *ngIf="!column.inlineGridSkipParent" [class]="getHeaderCssClass(column.key)">
                    <b>{{ getHeaderText(column.key) | translate }}</b>
                  </div>
                  <ng-container *ngFor="let child of column.children">
                    <div class="inline-grid-column" *ngIf="!getIsHidden(child, item)" [class]="getHeaderChildCssClass(column.key, child.key)">
                      <b>{{ getHeaderChildText(column.key, child.key) | translate }}</b>
                    </div>
                  </ng-container>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div class="inline-grid" [ngStyle]="{'grid-template-columns': column.inlineGridTemplate || 'unset'}">
                  <ng-container *ngTemplateOutlet="mobileGridCell; context: { column, item: (column.useParent ? parent : item), index, parent }"></ng-container>
                  <ng-container *ngFor="let child of column.children">
                    <ng-container *ngIf="!getIsHidden(child, item)">
                      <ng-container *ngTemplateOutlet="mobileGridCell; context: { column: child, item: (column.useParent ? parent : item), index, parent }"></ng-container>
                    </ng-container>
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </ng-container>
      </tbody>
    </table>
    <hr class="no-margin top-spacer">
  </div>
</ng-template>

<ng-template #cell let-column="column" let-item="item" let-index="index" let-parent="parent">
  <ng-container *ngIf="!getIsHidden(column, item)">
    <ng-container *ngIf="column.inlineGrid">
      <div class="inline-grid-column" *ngIf="!column.inlineGridSkipParent">
        <ng-container *ngTemplateOutlet="cellContentWithButtons; context: { column, item, index, parent }"></ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="!column.inlineGrid">
      <ng-container *ngTemplateOutlet="cellContentWithButtons; context: { column, item, index, parent }"></ng-container>
    </ng-container>
    <ng-container *ngFor="let child of column.children">
      <ng-container *ngIf="column.inlineGrid">
        <div class="inline-grid-column">
          <ng-container *ngTemplateOutlet="cell; context: { column: child, item, parent }">></ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="!column.inlineGrid">
        <ng-container *ngTemplateOutlet="cell; context: { column: child, item, parent }">></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #cellContent let-column="column" let-item="item" let-index="index" let-parent="parent">
  <ng-container *ngIf="!column.type && column.format || column.type === DataTableRowItemType.Text || column.type === DataTableRowItemType.SubText">
    <ng-container *ngTemplateOutlet="typeText; context: { column, item }"></ng-container>
  </ng-container>
  <ng-container *ngIf="column.type === DataTableRowItemType.Template">
    <ng-container *ngTemplateOutlet="typeTemplate; context: { column, item, index, parent }"></ng-container>
  </ng-container>
  <ng-container *ngIf="column.type === DataTableRowItemType.Link">
    <ng-container *ngTemplateOutlet="typeLink; context: { column, item }"></ng-container>
  </ng-container>
  <ng-container *ngIf="column.type === DataTableRowItemType.Checkbox">
    <ng-container *ngTemplateOutlet="typeCheckbox; context: { column, item, parent }"></ng-container>
  </ng-container>
  <ng-container *ngIf="column.type === DataTableRowItemType.Price">
    <ng-container *ngTemplateOutlet="typePrice; context: { column, item, parent }"></ng-container>
  </ng-container>
</ng-template>

<ng-template #cellContentWithButtons let-column="column" let-item="item" let-index="index" let-parent="parent">
  <ng-container *ngTemplateOutlet="cellContent; context: { column, item, index, parent }"></ng-container>
  <ng-container *ngIf="column.type === DataTableRowItemType.Button">
    <ng-container *ngFor="let button of column.buttons">
      <ng-container *ngTemplateOutlet="typeButton; context: { button, item }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #mobileHeaderCell let-column="column" let-item="item" let-index="index" let-parent="parent">
  <ng-container *ngIf="item && column.type === DataTableRowItemType.Checkbox">
    <mat-checkbox *ngIf="isClickable(item[column.value])" (change)="toggleItem($event, item[column.value], parent && config.parentValue ? parent[config.parentValue] : null)"
                  [checked]="isSelected(item[column.value], parent && config.parentValue ? parent[config.parentValue] : null)" [disabled]="item.disabled"></mat-checkbox>
  </ng-container>
  <div class="heading-5 text-base" *ngIf="!column.type && column.format || column.type === DataTableRowItemType.Text">
    {{ getHeaderText(column.key) | translate }} {{ formatText(column.format, item, column.useModel) | translate }}
  </div>
  <div class="heading-5 no-margin link bold" *ngIf="column.type === DataTableRowItemType.Link">
    <a (click)="$event.stopPropagation(); column.action(item)">
      <span>{{ formatText(column.format, item, column.useModel) | translate }}</span>
    </a>
  </div>
  <ng-container *ngIf="column.type === DataTableRowItemType.Template">
    <ng-container *ngTemplateOutlet="typeMobileTemplate; context: { column, item, index, parent }"></ng-container>
  </ng-container>
  <ng-container *ngIf="column.type === DataTableRowItemType.SubText">
    <br><small class="text-muted">{{ formatText(column.format, item, column.useModel) | translate }}</small>
  </ng-container>
  <div class="white-space-no-wrap flex decreased-margin" *ngIf="column.type === DataTableRowItemType.Button">
    <ng-container *ngIf="column.buttons.length > 2">
      <button mat-button class="input-button icon-button" [matMenuTriggerFor]="moreMenu">
        <mat-icon class="svg-icon" [svgIcon]="'menu_vert'"></mat-icon>
      </button>
      <mat-menu #moreMenu="matMenu" [xPosition]="'before'">
        <ng-container *ngFor="let button of column.buttons">
          <ng-container *ngTemplateOutlet="typeMenuButton; context: { button, item, column }"></ng-container>
        </ng-container>
      </mat-menu>
    </ng-container>
    <ng-container *ngIf="column.buttons.length < 3">
      <ng-container *ngFor="let button of column.buttons">
        <ng-container *ngTemplateOutlet="typeButton; context: { button, item }"></ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #mobileCell let-column="column" let-item="item" let-index="index" let-parent="parent">
  <td>
    <span [class]="'bold ' + getHeaderCssClass(column.key)">{{ getHeaderText(column.key) | translate }}</span>
    <span class="bold" *ngIf="getHeaderShowCurrency(column.key)">&nbsp;({{ authService.currencySymbol }})</span>
    <ng-container *ngFor="let child of column.children">
      <br>
      <span [class]="'medium ' + getHeaderChildCssClass(column.key, child.key)">{{ getHeaderChildText(column.key, child.key) | translate }}</span>
      <span class="medium" *ngIf="getHeaderChildShowCurrency(column.key, child.key)">&nbsp;({{ authService.currencySymbol }})</span>
    </ng-container>
  </td>
  <td class="align-right">
    <ng-container *ngTemplateOutlet="cellContent; context: { column, item, index, parent }"></ng-container>
  </td>
</ng-template>

<ng-template #mobileGridCell let-column="column" let-item="item" let-index="index" let-parent="parent">
  <div class="inline-grid-column" *ngIf="!column.inlineGridSkipParent">
    <ng-container *ngTemplateOutlet="cellContent; context: { column, item, index, parent }"></ng-container>
  </div>
</ng-template>

<ng-template #typeText let-column="column" let-item="item">
  <span [class]="column.cssClass">
    {{ formatText(column.format, item, column.useModel) | translate }}
    <span *ngIf="column.showCurrency">({{ authService.currencySymbol }})</span>
  </span>
</ng-template>

<ng-template #typeTemplate let-column="column" let-item="item" let-index="index" let-parent="parent">
  <ng-container *ngTemplateOutlet="column.template; context: { item, column, index, parent }"></ng-container>
</ng-template>
<ng-template #typeMobileTemplate let-column="column" let-item="item" let-index="index" let-parent="parent">
  <ng-container *ngTemplateOutlet="(column.templateMobile || column.template); context: { item, column, index, parent }"></ng-container>
</ng-template>

<ng-template #typeLink let-column="column" let-item="item">
  <a class="link" [class]="column.cssClass" (click)="$event.stopPropagation(); column.action(item)">
    <span>{{ formatText(column.format, item, column.useModel) | translate }}</span>
  </a>
</ng-template>

<ng-template #typeButton let-button="button" let-item="item">
  <button mat-button class="input-button icon-button" [class]="button.cssClass" [color]="button.color" *ngIf="!getIsHidden(button, item) && (!button.checkModel?.length || evaluate(button.checkModel, item))" (click)="$event.stopPropagation(); button.action(item)"
          [matTooltip]="button.tooltip | translate">
    <mat-icon class="svg-icon" [svgIcon]="button.icon"></mat-icon>
  </button>
</ng-template>
<ng-template #typeMenuButton let-button="button" let-item="item" let-column="column">
  <button mat-menu-item *ngIf="!getIsHidden(button, item) && (!button.checkModel?.length || evaluate(button.checkModel, item))"
          (click)="$event.stopPropagation(); button.action(item)">
    <mat-icon class="svg-icon" [svgIcon]="button.icon"></mat-icon>
    <span>{{ formatText(column.format, item, column.useModel) | translate}}</span>
  </button>
</ng-template>

<ng-template #typeCheckbox let-column="column" let-item="item" let-parent="parent">
  <ng-container *ngIf="item">
    <mat-checkbox *ngIf="isClickable(item[column.value])" (change)="toggleItem($event, item[column.value], parent && config.parentValue ? parent[config.parentValue] : null)"
                  [checked]="isSelected(item[column.value], parent && config.parentValue ? parent[config.parentValue] : null)" [disabled]="item.disabled"></mat-checkbox>
  </ng-container>
  <ng-container *ngIf="!item">
    <mat-checkbox (change)="toggleAll($event)"
                  [checked]="areAllSelected" [indeterminate]="areSomeSelected" [disabled]="column.disabled"></mat-checkbox>
  </ng-container>
</ng-template>

<ng-template #typePrice let-column="column" let-item="item" let-parent="parent">
  <span [class]="column.cssClass">
    {{ formatNumber(column.format, item, column.useModel) | price: !column.showCurrency  }}
  </span>
</ng-template>
